import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    fetch(farm, month, year, authType = 'HS') {
        const options = {
            method: 'get',
            url: `/umbraco/api/Authorizations/get?farm=${farm}&month=${month}&year=${year}&authType=${authType}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    fetchFeedReconciliationAuthorizations(farm, parentId) {
        const options = {
            method: 'get',
            url: `/umbraco/api/Authorizations/GetFeedReconciliationAuthorizations?farm=${farm}&parentId=${parentId}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    add(authorization) {

        const options = {
            method: 'post',
            url: `/umbraco/api/Authorizations/Add`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: authorization
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    addFeedRec(authorization) {

        const options = {
            method: 'post',
            url: `/umbraco/api/Authorizations/AddFeedRec`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: authorization
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}